import React from 'react';
import classNames from 'classnames';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import {
  images,
} from '../../../../assets/image';

const ThumbnailWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    defaultPaddings,
  } = props;
  return (
    <div
      className={classNames([styles.widgetContainer])}
      style={defaultPaddings}
    >
     <div className={classNames([styles.imageContainer])}>
      <img
          src={props.widgetParams.imageURL ? props.widgetParams.imageURL : images.placeHolder}
          className={classNames([styles.widgetImage])}
        />
     </div>
      <div
        className={classNames([styles.imageOverlay])}
      />
      <p
        className={styles.title}
      >
        {props.widgetParams.title}
      </p>
    </div>
  );
};

export default ThumbnailWidget;
